export default "__VITE_ASSET__CSDXbBu9__"